import React, { useState, useEffect } from 'react'
import PostLogin from '../../layout/postLogin'
import UserActivity from './components/userActivity'
import OverAllActivity from './components/overAllActivity'
// import ProjectTracker from './components/projectTracker'
import SystemAccessLog from './components/systemAccessLog'
import UserVerification from '../userManagement/components/userVerification'
import { NAME_ADMIN_TOOL } from '../../constants'
import { Wrapper } from './style'

const AdminTool = () => {
  const [isValidUser, setValidUser] = useState(true) // MAKE IT 'FALSE' TO ACTIVATE THIS VERIFICATION
  useEffect(() => {
    document.title = NAME_ADMIN_TOOL
  }, [])

  return (
    <PostLogin pageTitle={NAME_ADMIN_TOOL}>
      <Wrapper>
        {!isValidUser && <UserVerification onChange={() => setValidUser(true)} />}
        {isValidUser && <UserActivity />}
        {isValidUser && <OverAllActivity />}
        {isValidUser && <SystemAccessLog />}
        {/* {isValidUser && <ProjectTracker />} */}
      </Wrapper>
    </PostLogin>
  )
}

export default AdminTool
